module.exports = __webpack_public_path__ + "static/media/Kingrose_Villa.39dd61d8.pdf";